import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { driverSelector, fetchOnedriver } from "../../api/driver";
import { fetchAllbooking } from "../../api/bookings";
import seatbooking, { getAllBookings, seatBookSelector } from "../../api/seatbooking";

const CollabCard = ({ id, cafe, date, description, requirements, amount }) => {
  const navigate = useNavigate();

  const handleEditClick = () => {
    navigate(`/edit-collab/${id}`);
  };

  return (
    <div className="flex flex-col justify-between bg-white rounded-lg shadow-md p-6">
      <div className="flex flex-wrap justify-between items-start mb-4">
        <h2 className="text-lg font-semibold text-gray-800 max-w-full truncate">{cafe}</h2>
        <p className={`text-sm p-2 rounded-2xl text-green-500`}>{date}</p>
      </div>

      {/* <div className="mt-4 flex justify-between items-center">
        <span className="text-lg font-bold">₹{amount}</span>
      </div> */}
    </div>
  );
};

const Index = () => {
  const now = new Date();
  const dispatch = useDispatch();
  const [authStatus, setAuthStatus] = useState(null);
  const { driverAuthenticate } = useSelector(driverSelector);
  const { getAllBooks } = useSelector(seatBookSelector);
  const driver_id_ = localStorage.getItem("driverid") ||  localStorage.getItem("Driver");
  const navigate = useNavigate()

  // State for loading and error handling
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const driverid = localStorage.getItem("Driver");
        await dispatch(fetchOnedriver(driver_id_));
        await dispatch(fetchAllbooking(driver_id_));
        await dispatch(getAllBookings(driver_id_));
        setLoading(false);
      } catch (err) {
        setError("Failed to load bookings");
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch, driver_id_]);

  // Filter future bookings
  const futureBookings = getAllBooks?.filter(booking => {
    const rideDate = new Date(booking.rideDate);
    return rideDate < now;
  });

  // Format date display
  const formatDate = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  if (loading) return <div className="text-center py-12">Loading...</div>;
  if (error) return <div className="text-center py-12 text-red-500">{error}</div>;
  console.log(getAllBooks)
  return (
    <>
      {authStatus || driverAuthenticate ? (
        <div className="min-h-screen w-full max-w-screen-xl mx-auto px-4 py-6 mt-40 mb-16">
          <div className="mb-8 flex items-center justify-between">
            <button onClick={() => navigate(-1)} className="text-gray-600 hover:text-gray-800 hidden md:block">
              ← Go Back
            </button>
            <div className="text-center flex-1">
              <h2 className="text-3xl font-bold text-gray-800">Past Rides</h2>
              <p className="text-lg text-gray-600">Rides</p>
            </div>
          </div>

          {futureBookings?.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">No Previous rides scheduled</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 pb-10">
              {futureBookings?.map((booking) => (
                <CollabCard
                  key={booking._id}
                  id={booking._id}
                  cafe={`${booking?.route?.name}`}
                  date={formatDate(booking?.rideDate)}
                  amount={booking.fare}
                  requirements={booking.requirements}
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className="text-center py-12">
          <h1 className="text-2xl font-bold">Please log in first!</h1>
        </div>
      )}
    </>
  );
};

export default Index;